import { addShortcodeToEditor, getShortcodeWrapper } from "@/assets/utilities/tinymce/shortodeAddition";
import { getAudioFormTemplate } from "@/assets/utilities/tinymce/shortcodes/templates";
import { parseToHtml } from "@/utility/parseToHtml";

const editAudioFormConfig = (editor, shortcodeWrapper) => {
  let currentData = null;

  const audioFormWindow = editor.windowManager.openUrl({
    title: "Audio form",
    url: "/audio-form-dialog",
    buttons: [
      {
        type: "cancel",
        name: "close",
        text: "Cancel",
      },
      {
        type: "custom",
        name: "submit",
        text: "Submit",
        primary: true,
      },
    ],
    onAction: function (instance, message) {
      editor.windowManager.alert("Success!");
      shortcodeWrapper.setAttribute("data-audio-form-data", currentData);
      // We have to call change function here to updateMainContent in form component
      editor.fire("change");
      instance.close();
    },
    onMessage: (instance, message) => {
      if (message.mceAction === "requestData") {
        sendData();
      }

      if (message.mceAction === "updateAudioFormData") {
        currentData = message.data;
      }
    },
    width: window.innerWidth - 20,
    height: window.innerHeight - 20,
  });

  const sendData = () => {
    audioFormWindow.sendMessage({
      type: "sendData",
      data: shortcodeWrapper.getAttribute("data-audio-form-data"),
    });
  };
};

const audioFormConfig = (tinymce, uuid, shortcodeOnClick) => {
  let currentData = null;

  tinymce.activeEditor.windowManager.openUrl({
    title: "Audio form",
    url: "/audio-form-dialog?data=null",
    buttons: [
      {
        type: "cancel",
        name: "close",
        text: "Cancel",
      },
      {
        type: "custom",
        name: "submit",
        text: "Submit",
        primary: true,
      },
    ],
    onAction: function (instance) {
      const shortcodeWrapper = getShortcodeWrapper(
        uuid,
        shortcodeOnClick,
        getAudioFormTemplate(),
        "audio-form-shortcode",
      );
      const shortcodeWrapperEl = parseToHtml(shortcodeWrapper).querySelector(".shortcode");

      shortcodeWrapperEl.setAttribute("data-audio-form-data", currentData);

      addShortcodeToEditor(shortcodeWrapperEl.outerHTML, uuid);
      instance.close();
    },
    onMessage: (instance, message) => {
      currentData = message.data;
    },
    width: window.innerWidth - 20,
    height: window.innerHeight - 20,
  });
};

export { audioFormConfig, editAudioFormConfig };
